import styled from 'styled-components';
import { BrandCode } from 'types';

export const Reviews = styled.div`
	.css-1g6xtbq,
	.css-ulm043,
	.css-12t6rv,
	.css-y6eiwt,
	.css-1tpw5di,
	.css-1uh2en9,
	.css-18o1hlj,
	.css-bmykc4,
	.css-bjytwg {
		display: none;
	}

	.css-1dwjuyw {
		display: flex;
		flex-direction: column;
	}

	/* Ratings Modal - Bars Container */
	.css-1iyoj2o {
		max-width: 220px;
		margin-top: 3px;
	}

	/* Ratings Modal - Review Number In Parenthesis */
	.css-126dfbb {
		line-height: 15px;

		${({ theme }) =>
			({
				[BrandCode.Celebrity]: `
			font-size: 12px;
			`,
				[BrandCode.RoyalCaribbean]: `
			font-size: 14px;
			`
			})[theme.brandCode]}
	}

	/* Ratings Modal - Rating Distribution Label */
	.css-uthtre {
		${({ theme }) => `
    font-family: ${theme.typography.fontFamilyBold};
  `}

		${({ theme }) =>
			({
				[BrandCode.Celebrity]: `
		font-size: 14px;
    `,
				[BrandCode.RoyalCaribbean]: `
		font-size: 16px;
    `
			})[theme.brandCode]}
	}

	.css-1mxrd5z {
		margin: 0;
	}

	.css-wqc452 {
		margin: 0;
		min-width: 280px;
	}

	.css-1dgq94v {
		width: 280px;
	}
	max-width: 219px;
	max-height: 170px;
`;

export const ButtonReviews = styled.a`
	align-items: center;
	border-radius: 3px;
	position: relative;
	${({ theme }) => `
		background-color: ${theme.palette.primary.main};
  	`}
	color: #ffffff;
	display: inline-flex;
	font-family:
		Proxima Nova SemiBold,
		Verdana,
		Geneva,
		sans-serif;
	font-size: 16px;
	height: 42px;
	justify-content: center;
	line-height: 20px;
	padding: 11px 30px;
	text-decoration: none;
	width: 100%;

	/* Button - Container & Label */
	&.rating {
		margin-top: 5px;
	}
`;

export const Container = styled.div`
	max-height: 230px;
	overflow: hidden;
	button {
		z-index: 2;
	}
`;
